/* eslint-disable no-console */
import axios from 'axios';

import { getHttpBearerConfig, listArgsToQueryString } from '@services/httpServices';
import { getUserWithToken } from '@core/helpers/coreHelper';

import { API_URL_COMPANIES } from '@configs/appConfig';

import { Collections } from '@types/collectionsTypes';
import { subscribeToCollection } from '@services/firebaseServices';

const CACHE = [];

export const SERVICE_COLLECTION_NAME = Collections.COMPANIES;

export const listGrantedCompanies = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      if (!uwt.token) resolve(null);
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/granted${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const listPublicCompanies = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/public${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const listTrendingCompanies = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/trending${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const listRecentlyAddedCompanies = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/recently-added${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const listTopOpenToInvestCompanies = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/top-open-to-invest${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const getGrantedCompanyById = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const id = args.id;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/granted/${id}${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const listCompanies = (args) => {
  let disableCache = null;
  let filters = null;
  if (args) disableCache = args.disableCache;
  if (args) filters = args.filters;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    if (!disableCache) {
      const cacheItem = CACHE.find((item) => {
        return JSON.stringify(qs) === JSON.stringify(item.query);
      });
      if (cacheItem) {
        resolve(cacheItem.value);
        return;
      }
    }

    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          const cacheItemIndex = CACHE.findIndex((item) => {
            return JSON.stringify(qs) === JSON.stringify(item.query);
          });

          const cacheData = { query: qs, value: response.data };
          if (cacheItemIndex >= 0) {
            CACHE[cacheItemIndex] = cacheData;
          } else {
            CACHE.push(cacheData);
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const listUserCompanyHistoryById = (args) => {
  let filters = null;

  if (args) filters = args.filters;

  const id = args.id;

  const qs = listArgsToQueryString({ filters });
  return new Promise((resolve, reject) => {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/historyInsight/${id}${qs}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const subscribeCompanies = ({ onUpdate, onError, filters }) => {
  const qs = listArgsToQueryString({ filters });

  return new Promise((resolve, reject) => {
    const cacheItem = CACHE.find((item) => {
      return item.query === qs;
    });

    // TODO MICHEL - Siempre devuelve dos veces onUpdate, ver como no hacer el segundo onUpdate...
    if (cacheItem) onUpdate(cacheItem.value);

    try {
      const unsub = subscribeToCollection({
        path: SERVICE_COLLECTION_NAME,

        onUpdate: (documents) => {
          listCompanies({ disableCache: true, filters })
            .then((results) => {
              const newCacheItem = CACHE.find((item) => {
                return item.query === qs;
              });

              if (!newCacheItem) {
                reject(new Error('No se genero la cache'));
                return;
              }

              onUpdate(newCacheItem.value);
            })
            .catch((e) => {
              reject(e);
            });
        },
        onError: (e) => {
          console.error('Error subscribe:', e);
          onError(new Error(`${SERVICE_COLLECTION_NAME} error: ${e.message}`));
        },
      });

      resolve(unsub);
    } catch (e) {
      reject(e);
    }
  });
};

export const getCompany = (id) => {
  return new Promise(function (resolve, reject) {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/${id}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const quickCreateCompany = (itemData) => {
  return new Promise(function (resolve, reject) {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      axios
        .post(`${API_URL_COMPANIES}/quick-create`, itemData, config)
        .then((response) => {
          if (!response) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const switchCompany = ({ companyId }) => {
  return new Promise(function (resolve, reject) {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      const itemData = {};

      axios
        .post(`${API_URL_COMPANIES}/switch-company/${companyId}`, itemData, config)

        .then((response) => {
          if (!response) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }

          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const updateCompany = (id, itemData) => {
  console.log('update', itemData);
  return new Promise(function (resolve, reject) {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      axios
        .patch(`${API_URL_COMPANIES}/${id}`, itemData, config)
        .then((response) => {
          if (!response) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};

export const getRelatedInvestActive = ({ companyId }) => {
  return new Promise(function (resolve, reject) {
    getUserWithToken().then((uwt) => {
      const config = getHttpBearerConfig(uwt ? uwt.token : null);

      console.log('REQUESTING ', API_URL_COMPANIES);
      axios
        .get(`${API_URL_COMPANIES}/related-invest-active/${companyId}`, config)
        .then((response) => {
          if (!response || !response.data) {
            console.error('Invalid response');
            throw new Error('Invalid response');
          }
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
};
